import { createUseStyles } from 'react-jss'
import { colors, zIndexes, sizes } from '../../variables.style'

const sectionPadding = '10px 0'
const topPadding = '80px'
const containerPadding = '56px'
const topNavPadding = `${sizes.navHeight} + ${topPadding}`

export const style = {
  executiveSummaryContainer: {
    height: `calc(100% - ${topPadding})`,
    width: '100%',
    overflow: 'hidden scroll',
    position: 'absolute',
    top: topPadding,
    left: 0,
    padding: `0 ${containerPadding}`
  },
  executiveSummaryContent: {
    display: 'flex'
  },
  scrollContainer: {
    position: 'absolute',
    width: '100%',
    overflow: 'hidden',
    top: 0,
    left: 0
  },
  headerSection: {
    height: `calc(100vh - (${topNavPadding}))`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    transition: '0.4s ease-in-out',
    opacity: 0,
    zIndex: 0,
    pointerEvents: 'none',
    '&.show': {
      pointerEvents: 'auto',
      zIndex: 1,
      opacity: 1
    }
  },
  headerSectionSafari: {
    height: `calc(100svh - (${topNavPadding}))`
  },
  headerSectionContent: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    textAlign: 'center',
    letterSpacing: 3,
    padding: sectionPadding,
    marginBottom: 10
  },
  headerTitle: {
    composes: 'h1 report-full-width',
    padding: 5,
    margin: 5
  },
  headerDescription: {
    composes: 'report-full-width',
    maxWidth: 840,
    letterSpacing: 1.5,
    fontSize: 18,
    whiteSpace: 'pre-line',
    padding: 5
  },
  executiveSummarySection: (props = {}) => ({
    inset: 0,
    margin: '0 auto',
    paddingTop: '40px', // leave room for block actions at the top (sticky sections)
    width: '100%',
    zIndex: 0,
    opacity: 0,
    transition: props.blockIndex > 0 ? 'opacity 0.4s ease-in-out' : 'none',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    '&.show': {
      pointerEvents: 'auto',
      opacity: 1,
      transition: 'opacity 0.4s ease-in-out',
      position: props.renderType === 'sticky' ? 'sticky' : 'absolute'
    },
    '&.show $blockDescription': {
      opacity: 1,
      transitionDelay: '.2s',
      transition: '.6s ease-in-out',
      transform: 'translateY(0)'
    }
  }),
  pageLayoutWrapper: {
    margin: '0 auto',
    marginTop: -80
  },
  arrowButtonContainer: {
    position: 'absolute',
    bottom: '4px'
  },
  arrowButton: {
    border: 'none',
    background: 'none',
    fontSize: 20,
    transition: '0.3s ease-in-out',
    color: colors.brandDark,
    '&:hover': {
      cursor: 'pointer'
    },
    '& span': {
      color: colors.textGray,
      display: 'block',
      fontSize: 36,
      marginTop: 12,
      animation: 'arrow-bounce 2.4s infinite'
    }
  },
  arrowButtonAnimate: {
    border: 'none',
    background: 'none',

    transition: '0.3s ease-in-out',

    '&:hover': {
      cursor: 'pointer'
    },
    color: colors.textGray,
    fontSize: 36,
    marginTop: 12,
    animation: 'arrow-bounce 2.4s infinite'

  },
  blockContainer: {
    zIndex: 1,
    flex: '1 1 auto',
    scrollMarginTop: '40px', // room at the top for block actions (scrollable blocks)
    paddingBottom: (props) => props && props.isLast ? '40px' : 0, // room at the bottom for the "View full report" button
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  blockDescription: {
    maxWidth: 360,
    width: '100%',
    marginLeft: 10,
    whiteSpace: 'pre-wrap',
    fontSize: 20,
    opacity: 0,
    transform: 'translateY(10px)',
    transition: 'none',
    '& p': {
      position: 'sticky',
      top: 0
    }
  },
  progressSidebar: {
    zIndex: 4,
    right: 32,
    top: topPadding,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'absolute',
    height: `calc(100vh - (${topNavPadding}))`,
    opacity: 0,
    transition: 'opacity 0.4s ease-in-out',
    '&.flexible $progressSidebarInner': {
      height: 'calc(100% - 8px)'
    },
    '&.flexibleCondensed $progressSidebarInner': {
      height: 'calc(100% - 8px)'
    },
    '&.simple $progressSidebarInner': {
      height: 'calc(100% - 8px)'
    },
    '&.flexible $progressSidebarInner $progressSidebarItem + $progressSidebarItem': {
      marginTop: 0
    },
    '&.flexibleCondensed $progressSidebarInner $progressSidebarItem + $progressSidebarItem': {
      marginTop: 0
    },
    '&.flexibleCondensed $progressSidebarInner $progressSidebarItem': {
      width: 10,
      height: 10
    },
    '&.simple': {
      right: 37
    },
    '&.simple $progressSidebarInner $progressSidebarItem': {
      display: 'none'
    },
    '&.simple $progressSidebarLine::before': {
      width: 3,
      borderRadius: '24px'
    },
    '&.simple $progressSidebarActiveTracker': {
      width: 3,
      transition: 'none'
    }
  },
  progressSidebarSafari: {
    height: `calc(100svh - (${topNavPadding}))`

  },
  progressSidebarInner: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  progressSidebarLine: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: -1,
    '&:before': {
      content: '""',
      margin: '0 auto',
      width: 2,
      height: '100%',
      background: colors.gray,
      position: 'absolute',
      top: 0,
      zIndex: 1
    }
  },
  progressSidebarActiveTracker: {
    margin: '0 auto',
    width: 2,
    background: colors.brandPrimary,
    position: 'absolute',
    top: 0,
    zIndex: 2
  },
  progressSidebarItem: {
    cursor: 'pointer',
    position: 'relative',
    width: 12,
    height: 12,
    minHeight: 10,
    borderRadius: '100%',
    display: 'block',
    border: `2px solid ${colors.gray}`,
    transition: '0.2s ease-in-out',
    background: colors.backgroundGray,
    '&.borderHighlight': {
      borderColor: colors.brandPrimary
    },
    '&.active': {
      background: colors.brandPrimary
    },
    '& + &': {
      marginTop: 32
    }
  },
  progressSidebarItemPopoverTrigger: {
    position: 'absolute',
    top: -2,
    left: -2,
    width: 'calc(100% + 4px)',
    height: 'calc(100% + 4px)'
  },
  progressSidebarPopoverContainer: {
    whiteSpace: 'nowrap',
    transition: '0.3s ease-in-out'
  },
  progressSidebarPopover: {
    composes: 'tooltip-content',
    textTransform: 'none',
    fontSize: '16px',
    left: 6,
    maxWidth: 300,
    '& > div': {
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  },
  reportLinkContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 56,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    zIndex: zIndexes.executiveSummaryFullReportLink,
    '& > a': {
      background: colors.brandPrimary,
      height: 32,
      lineHeight: '32px',
      paddingLeft: 14,
      paddingRight: 14,
      textDecoration: 'none',
      borderRadius: 32,
      color: 'white',
      opacity: 0.8,
      transition: '.25s ease-in-out',
      '&:hover': {
        opacity: 1,
        boxShadow: '0 3px 10px rgb(0 0 0 / 0.35)'
      }
    }
  }
}

export const useStyles = createUseStyles(style)
